import { MovementsCapsule } from "./MovementsCapsule";
import { GameVars } from "../../GameVars";
import { GameConstants } from "../../GameConstants";

export class ChallengeHUD extends Phaser.Group {

    public initialTurnMessage: Phaser.Image;

    private movementsCapsule: MovementsCapsule;

    constructor(game: Phaser.Game) {

        super(game, null, "hud");

        this.initialTurnMessage = null;

        let text = GameVars.problemsData[GameVars.currentLevel].name;
        let font = "22px Roboto Slab Regular";

        if (text.length <= 40) {
            font = "28px Roboto Slab Regular";
        } else if (text.length <= 60) {
            font = "25px Roboto Slab Regular";
        }

        const label = new Phaser.Text(this.game, GameConstants.GAME_WIDTH / 2, 558 + (410 * GameVars.scaleY), text, { font: font, fontWeight: "600", fill: "#1b2d3d", align: "center"});
        label.anchor.set(.5, 0);
        label.scale.y = GameVars.scaleY;
        this.add(label);
        
        this.movementsCapsule = new MovementsCapsule(this.game);
        this.add(this.movementsCapsule);
    }

    public startGame(): void {

        // 
    }

    public checkmate(): void {

        this.movementsCapsule.destroy();
    }

    public showMovementCapsule(): void {
        
        this.movementsCapsule.visible = true;
    }

    public updateMoves(): void {

        this.movementsCapsule.updateMoves();
    }
}

